import { AnimatePresence, motion } from 'motion/react'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CampaignMediaType } from 'src/services/apollo/generated/graphql'
import { cx } from 'src/utils/cx'
import { MediaStreamPlayer } from '../Media/MediaStreamPlayer'
import { Preloader } from '../Preloader/Preloader'

export function AdLabel(props: { className: string }) {
  const { t } = useTranslation(['growth'])
  return (
    <div
      className={cx(
        props.className,
        'bg-[#F2F2F2]/70 text-[#8F8E90] text-xs rounded-md px-1',
      )}
    >
      {t('growth:ad-unit.ad-label')}
    </div>
  )
}

export function AdMedia(props: {
  className?: string
  mediaType?: CampaignMediaType
  mediaSpec?: string
  mediaAlt?: string
}) {
  const [mediaLoading, setMediaLoading] = useState(true)

  const onMediaLoad = useCallback(() => {
    setMediaLoading(false)
  }, [])
  const showPreloader =
    props.mediaType !== CampaignMediaType.Image && mediaLoading

  const mediaContent = (() => {
    if (!props.mediaSpec) {
      return null
    }
    if (props.mediaType === CampaignMediaType.Image) {
      return (
        <img
          className={cx(props.className, 'object-contain')}
          src={props.mediaSpec}
          fetchPriority="high"
          alt={props.mediaAlt || 'Ad'}
        />
      )
    } else {
      return (
        <MediaStreamPlayer
          mediaType={props.mediaType}
          mediaSpec={props.mediaSpec}
          commonProps={{
            onCanPlay: onMediaLoad,
          }}
          className={props.className}
          videoMediaProps={{
            className: 'object-contain',
          }}
          hlsStreamProps={{
            className: 'pointer-events-none',
          }}
          streamProps={{
            className: 'pointer-events-none',
          }}
        />
      )
    }
  })()

  return (
    <>
      {mediaContent}
      <AnimatePresence>
        {showPreloader ? (
          <motion.div
            className="absolute inset-0 bg-white/40 flex justify-center items-center"
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              transition: {
                delay: 0.3,
                duration: 0.2,
                ease: 'easeOut',
              },
            }}
            exit={{
              opacity: 0,
              transition: {
                duration: 0.125,
                ease: 'easeIn',
              },
            }}
          >
            <Preloader />
          </motion.div>
        ) : null}
      </AnimatePresence>
    </>
  )
}
